import React from 'react';
import * as S from './styles';

function PagePDF({page}){
    return(
        <S.TextFooter>{page}</S.TextFooter>
    )
};

export default PagePDF;